import type { ReactNode } from "react";
import { Trans } from "react-i18next";

/**
 * PageHeader (ADR 0016 rule 10): large title with an optional gradient emphasis word, subtitle,
 * and a right-aligned italic brand line. The title is an i18n key whose `<em>` marks the
 * gradient word, so translators decide which word carries the emphasis.
 */
export function PageHeader({
  titleKey,
  values,
  subtitle,
  brandLine,
  actions,
}: {
  titleKey: string;
  values?: Record<string, string>;
  subtitle?: ReactNode;
  brandLine?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <div className="flex items-start justify-between gap-8">
      <div className="min-w-0">
        <h1 className="text-[40px] font-semibold leading-[1.1] tracking-[-0.02em] text-ink">
          <Trans
            i18nKey={titleKey}
            values={values}
            components={{ em: <span className="text-gradient" /> }}
          />
        </h1>
        {subtitle && <p className="mt-2 text-[22px] leading-snug text-ink-2">{subtitle}</p>}
      </div>
      <div className="flex shrink-0 flex-col items-end gap-4">
        {brandLine && (
          <p className="max-w-64 text-right text-[19px] italic leading-snug text-ink-2">
            {brandLine}
          </p>
        )}
        {actions}
      </div>
    </div>
  );
}
